import { Action, createReducer, on } from "@ngrx/store";
import { clearPolicies, setPolicies } from "./policy.actions";
import { Policy } from "../../core/models/policy";

function byPolicyNumberAscending(a: Policy, b: Policy): number {
  return a.policyNumber > b.policyNumber ? 1 : -1;
}

export const featureKey = "policyStore";

export interface State {
  policies: Policy[];
}

const initalState: State = {
  policies: [],
};

const featureReducer = createReducer(
  initalState,
  on(clearPolicies, (state, action): State => {
    return {
      policies: [],
    };
  }),
  on(setPolicies, (state, action): State => {
    return {
      policies: [...action.policies].sort(byPolicyNumberAscending),
    };
  })
);

export function reducer(state: State | undefined, action: Action) {
  return featureReducer(state, action);
}
